
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

export default function Header() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-40">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/aad761441c4615b4ec8ab9e4024e3637/3a53a6d0d699cfca922322d0c183847b.png" 
              alt="Eyad Investment" 
              className="h-12 w-12 object-contain"
            />
            <div>
              <div className="text-xl font-bold text-black">亞德貝增財務顧問有限公司</div>
              <div className="text-xs text-gray-600">Eyad Investment</div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link 
              to="/" 
              className={`text-base font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/') ? 'text-yellow-600' : 'text-gray-700 hover:text-yellow-600'
              }`}
            >
              首頁
            </Link>
            <Link 
              to="/about" 
              className={`text-base font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/about') ? 'text-yellow-600' : 'text-gray-700 hover:text-yellow-600'
              }`}
            >
              關於我們
            </Link>
            <Link 
              to="/services" 
              className={`text-base font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/services') ? 'text-yellow-600' : 'text-gray-700 hover:text-yellow-600'
              }`}
            >
              服務項目
            </Link>
            <a 
              href="https://eyad.kaik.io" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-base font-semibold text-gray-700 hover:text-yellow-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              觀點文章
            </a>
            <Link 
              to="/#consultation" 
              className="bg-yellow-500 hover:bg-yellow-600 text-black px-6 py-2.5 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              立即諮詢
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`text-2xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden py-6 border-t border-gray-200">
            <div className="flex flex-col gap-4">
              <Link 
                to="/" 
                className={`text-base font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isActive('/') ? 'text-yellow-600' : 'text-gray-700'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                首頁
              </Link>
              <Link 
                to="/about" 
                className={`text-base font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isActive('/about') ? 'text-yellow-600' : 'text-gray-700'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                關於我們
              </Link>
              <Link 
                to="/services" 
                className={`text-base font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isActive('/services') ? 'text-yellow-600' : 'text-gray-700'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                服務項目
              </Link>
              <a 
                href="https://eyad.kaik.io" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-base font-semibold text-gray-700 transition-colors whitespace-nowrap cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                觀點文章
              </a>
              <Link 
                to="/#consultation" 
                className="bg-yellow-500 hover:bg-yellow-600 text-black px-6 py-2.5 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                立即諮詢
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
